import { FIELDS } from "lib"

export const MODULE_TABLE_COLUMNS = [
    { id: FIELDS.name.key, label: FIELDS.name.name },
    { id: FIELDS.description.key, label: FIELDS.description.name },
    { id: FIELDS.icon.key, label: FIELDS.icon.name },
    { id: FIELDS.relativePath.key, label: FIELDS.relativePath.name },
]

export const MODULE_DESCRIPTION_MAX_LENGTH = 45